import { ApiService } from '..';

const suffix = window.EXPORT_TYPE_SCORM ? '.json' : ''

export const UITextsService = {

    getTexts() {
        return ApiService.get(`uitexts${suffix}`, null);
    },

    getLanguage() {
        return ApiService.get(`language${suffix}`, null, false);
    },

    switchLanguage(language) {
        return ApiService.post('switchLanguage', { language });
    }
};
